// extracted by mini-css-extract-plugin
export default {"block":"Pu_CZ","bold":"OemfG","icon":"WhVfm","tooltip":"rNPFL"};